var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import theme from '../../../theme';
import AccountCreditsTableHeader from '../../../ui/organisms/AccountCreditsTableHeader';
import AccountCreditsTableRow from '../../../ui/organisms/AccountCreditsTableRow';
var TableContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > * {\n    border-bottom: 1px solid ", ";\n  }\n"], ["\n  & > * {\n    border-bottom: 1px solid ", ";\n  }\n"])), theme.colors.lightGrey);
var AccountCreditsTable = function (_a) {
    var accountCredits = _a.accountCredits;
    return (_jsxs(TableContainer, { children: [_jsx(AccountCreditsTableHeader, {}), accountCredits.map(function (accountCredit) { return (_jsx(AccountCreditsTableRow, { accountCredit: accountCredit })); })] }));
};
export default AccountCreditsTable;
var templateObject_1;
//# sourceMappingURL=index.js.map